import { IApplicationState } from '../../types/redux';

export function getUser(state: IApplicationState) {
  return state.user;
}
